import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatName'
})
export class FormatNamePipe implements PipeTransform {
    transform(value?: string): string {

        if (!value) {
            return '';
        }
        
        return value.split('/').pop();
    }
}
